/**
 * Server-safe column ids + table display defaults for DEFAULT_USER_DISPLAY_PREFERENCES.
 * Keep in sync with ./columns.tsx.
 */

export const learning_unit_tree_column_display_seeds: {
    id: string;
    defaultDisplayPreferences: {
        order: number;
        size: number;
        visible: boolean;
        pinned: boolean;
        displayAs: "number" | "string" | "date" | "other";
    };
}[] = [
    {
        id: "code",
        defaultDisplayPreferences: {
order: 1, size: 120, visible: true, displayAs: "string", pinned: false
        },
    },
    {
        id: "title",
        defaultDisplayPreferences: {
order: 2, size: 250, visible: true, displayAs: "string", pinned: true
        },
    },
    {
        id: "description",
        defaultDisplayPreferences: {
order: 3, size: 300, visible: true, displayAs: "string", pinned: false
        },
    },
    {
        id: "color",
        defaultDisplayPreferences: {
order: 4, size: 100, visible: true, displayAs: "other", pinned: false
        },
    },
    {
        id: "createdAt",
        defaultDisplayPreferences: {
order: 5, size: 150, visible: true, displayAs: "date", pinned: false
        },
    },
];
